import { render } from "./BaseTab.vue?vue&type=template&id=65d735c8&scoped=true"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"

import "./BaseTab.vue?vue&type=style&index=0&id=65d735c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d735c8"]])

export default __exports__